module.exports = __webpack_public_path__ + "img/11a.0410e5b8.jpg";